import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/view/order',
      data
    });
  },
  getAllCoin() {
    return http.get({
      url: '/la/admin/pair/list'
    });
  },
  cancel(data) {
    return http.post({
      url: '/la/admin/order/cancel',
      data,
      dataType: 'form'
    });
  },
  refresh(data) {
    return http.post({
      url: '/la/admin/refresh/order',
      data,
      dataType: 'form'
    });
  }
};
